export const DEFAULT_AUTH_ROUTE = '/home';
